module.exports = __webpack_public_path__ + "img/no-photo.1aadbd8a.png";